import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';

import { IAppointmentSlot } from '../models/public-provider-calendar.interface';
import { ProviderCalendarHttpService } from '../services/provider-calendar.httpservice';

@Injectable({
  providedIn: 'root'
})
export class ProviderCalendarStore {
  private cachedAppointmentSlots: Record<number, IAppointmentSlot[]> = {};

  constructor(private providerCalendarHttpService: ProviderCalendarHttpService) {}

  getAppointmentSlots$(
    providerPersonaId: number,
    providerTimeZone: string,
    forceRefresh = false
  ): Observable<IAppointmentSlot[]> {
    if (!forceRefresh && this.cachedAppointmentSlots[providerPersonaId]) {
      return of(this.cachedAppointmentSlots[providerPersonaId]);
    }

    return this.providerCalendarHttpService.getAppointmentSlots$(providerPersonaId, providerTimeZone).pipe(
      tap((slots) => {
        this.cachedAppointmentSlots[providerPersonaId] = slots;
      })
    );
  }
}
